import { render, staticRenderFns } from "./MaxBannerNew.vue?vue&type=template&id=134ae659&scoped=true&"
import script from "./MaxBannerNew.vue?vue&type=script&lang=js&"
export * from "./MaxBannerNew.vue?vue&type=script&lang=js&"
import style0 from "./MaxBannerNew.vue?vue&type=style&index=0&id=134ae659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ae659",
  null
  
)

export default component.exports